import {
  put, takeLatest, all, call,
} from 'redux-saga/effects';

import { startLoading, doneLoading } from 'domain/layout/actions';
import { exception } from 'circe/logger';
import { fetch, fetching, fetched } from './actions';
import * as API from './api';

function* doFetch() {
  try {
    yield put(fetching());

    const currency = yield call(API.fetch);

    if (!currency) {
      throw new Error('Unable to fetch currency');
    }

    yield put(fetched(currency));
  } catch (e) {
    exception(e);

    yield put(fetched(DEFAULT_CURRENCY));

    console.error('failed to get user location');
  }
}

function* watcher() {
  yield all([takeLatest(startLoading().type, doFetch)]);
}

export default watcher;
